// ProductMenuListItem.js
import { useState, useEffect } from "react";
import canna42 from "../assets/imgPlaceholder.png";
import btnStyles from "../styles/globalButtonStylng.module.css"

const MenuAddProductFromBrandItem = ({
  product, addItem,removeItem
}: {
  product: any;
  addItem: Function;
  removeItem:Function;
}) => {
  
  const [selected, setSelected] = useState<Boolean>(false);
  const [imageSrc, setImageSrc] = useState<string>(product.avatarUrl || canna42);
  const [buttonMargin, setButtonMargin] = useState(0);
  const [bgColor, setBgColor] = useState("#FFF");
  //for adjusting styles when selected
  useEffect(()=>{
    if(selected){
      setButtonMargin(-20);
      setBgColor("#EBEBEB");
    }else{
      setButtonMargin(-8);
      setBgColor("#FFF");
    }
  },[selected])
    // Function to handle the image error
    const handleImageError = () => {
      setImageSrc(canna42); // Set the source to the default image on error
    };

  const selectOrDeselect = (e:any)=>{
    if(selected){
        removeItem(product.id);
        setSelected(false);
    }else{
        addItem(product);
        setSelected(true);
    }
  }

  return (
    <>
        <div style={{ border: "1px solid #00b894", backgroundColor: bgColor, borderRadius:15 }} className="row m-2 p-2 align-items-center">
          <div className="col-sm-1">
                <img
                  src={imageSrc}
                  alt={product.name}
                  style={{
                    width: "300%",
                    borderRadius:5,
                    marginLeft:-15
                  }}
                  onError={handleImageError}
                />
            </div>
            <div className="col-sm-4 text-wrap">
              {product.name}
            </div>
            <div className="col-sm-3">{product.category.name}</div>
            <div className="col-sm-2">{product.strain}</div>
            <div className="col-sm-2" style={{marginLeft: buttonMargin}}><button className={selected? btnStyles.Cancel : btnStyles.Basic} onClick = {selectOrDeselect}>{selected? "Remove" : "Select"}</button></div>
        </div>
    </>
  );
};

export default MenuAddProductFromBrandItem;
